// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BrandListItem__icon":"uq_a bha_jx","BrandListItem__name":"uq_b bha_uj"};